import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Home from "./pages/Home";
import Practice from "./pages/Practice";
import Progress from "./pages/Progress";
import QuickPractice from "./pages/QuickPractice";
import BulkImport from "./pages/BulkImport";
import AdminDashboard from "./pages/AdminDashboard";
import Auth from "./pages/Auth";
import Subscribe from "./pages/Subscribe";
import AdminCodes from "./pages/AdminCodes";
import Account from "./pages/Account";
import useStore from "./store/useStore";
import useAuthStore from "./store/useAuthStore";
import { initTracking } from "./lib/tracking";

// Protected Route component
const ProtectedRoute = ({ children, requireSubscription = false }) => {
  const { user, token } = useAuthStore();
  
  if (!token || !user) {
    return <Navigate to="/auth" replace />;
  }
  
  if (requireSubscription && !user.has_access) {
    return <Navigate to="/subscribe" replace />;
  }
  
  return children;
};

function App() {
  const { darkMode } = useStore();
  const { refreshUser, token } = useAuthStore();

  useEffect(() => {
    if (darkMode) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [darkMode]);

  // Refresh user data on mount + track visit source
  useEffect(() => {
    initTracking();
    if (token) {
      refreshUser();
    }
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/quick-practice" element={<QuickPractice />} />
        <Route path="/admin/bulk-import" element={<BulkImport />} />
        <Route 
          path="/admin/dashboard" 
          element={
            <ProtectedRoute requireSubscription>
              <AdminDashboard />
            </ProtectedRoute>
          } 
        />
        <Route path="/auth" element={<Auth />} />
        <Route path="/subscribe" element={<Subscribe />} />
        <Route path="/subscribe/success" element={<Subscribe />} />
        <Route 
          path="/practice" 
          element={
            <ProtectedRoute requireSubscription>
              <Practice />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/progress" 
          element={
            <ProtectedRoute requireSubscription>
              <Progress />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/admin/codes" 
          element={
            <ProtectedRoute>
              <AdminCodes />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/account" 
          element={
            <ProtectedRoute>
              <Account />
            </ProtectedRoute>
          } 
        />
        <Route path="/redeem" element={<Subscribe />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
